import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { system } from 'styled-system';
import { COMMON, TYPOGRAPHY, get } from './constants';
import theme from './theme';
import sx from './sx';
var buttonStyles = {
  display: 'inline-block',
  padding: '0',
  fontSize: 'inherit',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  backgroundColor: 'transparent',
  border: '0',
  appearance: 'none'
};
var hoverColor = system({
  hoverColor: {
    property: 'color',
    scale: 'colors'
  }
});
var Link = styled.a.attrs(function (props) {
  return {
    color: props.color ? props.color : props.muted ? 'gray.6' : 'blue.5'
  };
}).withConfig({
  displayName: "Link",
  componentId: "kudw2l-0"
})(["text-decoration:", ";&:hover{text-decoration:", ";", ";}", ";", " ", ";", ";"], function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  return props.muted ? 'none' : 'underline';
}, function (props) {
  return props.hoverColor ? hoverColor : props.muted ? "color: ".concat(get('colors.blue.5')(theme)) : '';
}, function (props) {
  return props.as === 'button' ? buttonStyles : '';
}, TYPOGRAPHY, COMMON, sx);
Link.defaultProps = {
  theme: theme
};
Link.propTypes = _objectSpread(_objectSpread(_objectSpread({
  as: PropTypes.elementType,
  hoverColor: PropTypes.string,
  href: PropTypes.string,
  muted: PropTypes.bool,
  theme: PropTypes.object,
  underline: PropTypes.bool
}, TYPOGRAPHY.propTypes), COMMON.propTypes), sx.propTypes);
export default Link;